export const ResumeLink = () => {
  window.open(
    "https://drive.google.com/file/d/1Ng1ZOWN6FPvIX7ful22cxn_s69xlmMpI/view?usp=sharing"
  );
};
